import { isFuture } from 'date-fns'

import type { OrchestratedAuction } from '@b-stock/fe-core/bstock-next/queries'

// Minimal interface for what getIsWithinBuyNowWindow actually needs
interface BuyNowCapableAuction {
  buyNow?: {
    enabled?: boolean
    endTime?: string
  }
  closed?: boolean
  canceled?: boolean
}

const getIsWithinBuyNowWindow = (
  auction: OrchestratedAuction | BuyNowCapableAuction
) => {
  if (
    auction.buyNow?.enabled &&
    auction.buyNow.endTime &&
    !auction.closed &&
    !auction.canceled
  ) {
    return isFuture(auction.buyNow.endTime)
  }
  return false
}

export default getIsWithinBuyNowWindow
